import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

declare const window;
declare const InstallTrigger: any;


@Injectable({
  providedIn: 'root'
})
export class EnvService {

  constructor(
    private http: HttpClient
  ) {}

  // Return user browser ('Opera'/'Firefox'/'Safari'/'Chrome'/'IE'/'Edge'/'Blink'/'Unknown browser')
  getBrowser(): string {
    // Opera 8.0+
    const isOpera = (!!window['opr'] && !!window['opr'].addons) || !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0;
    // Firefox 1.0+
    const isFirefox = typeof InstallTrigger !== 'undefined';
    // Safari 3.0+ "[object HTMLElementConstructor]"
    const isSafari = /constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === '[object SafariRemoteNotification]'; })(!window['safari'] || window['safari'].pushNotification);
    // Internet Explorer 6-11
    const isIE = !!window.document['documentMode'];
    // Edge 20+
    const isEdge = !isIE && !!window.StyleMedia;
    // Chrome 1+
    const isChrome = !!window.chrome && !!window.chrome.webstore;
    // Blink engine detection
    const isBlink = (isChrome || isOpera) && !!window.CSS;

    return isOpera ? 'Opera' : isFirefox ? 'Firefox' : isSafari ? 'Safari' : isChrome ? 'Chrome' : isIE ? 'IE' : isEdge ? 'Edge' : isBlink ? 'Blink' : 'Unknown browser';
  }

  // Return type of the user device ('window'/'mobile')
  getDevice(): string {
    const userAgent = window.navigator.userAgent;

    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile|mobile/i.test(userAgent)) {
      return 'mobile';
    } else {
      return 'window';
    }
  }

  // Return user ip address
  getIpAddress(): Observable<any> {

    return this.http.jsonp('https://jsonip.com', 'callback')
      .map(
        (response: any) => response.ip
      )
  }
}
